require('./insuranceRequestRelatedWizard.scss');
require('./insuranceRequestRelatedWizard.override.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { PROC_STEP, recordProcess } = require('utilities/tagging');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
const InsuranceRequestCompilationCard = require('../insuranceRequestCompilationCard/insuranceRequestCompilationCard');
const InsuranceRequestWizardStep1 = require('./insuranceRequestWizardStep1/insuranceRequestWizardStep1');
const InsuranceRequestWizardStep2Related = require('./insuranceRequestWizardStep2/insuranceRequestWizardStep2Related');
const InsuranceRequestWizardStep3 = require('./insuranceRequestWizardStep3/insuranceRequestWizardStep3');
const InsuranceRequestWizardStep3CC = require('./insuranceRequestWizardStep3/insuranceRequestWizardStep3CC');
const InsuranceRequestWizardStep4 = require('./insuranceRequestWizardStep4/insuranceRequestWizardStep4');
const InsuranceRequestWizardStep5 = require('./insuranceRequestWizardStep5/insuranceRequestWizardStep5');
const InsuranceRequestDetailsTabsWrapper = require('../insuranceRequestDetails/insuranceRequestDetailsTabsWrapper');
const InsuranceRequestRelatedWizardSaved = require('./insuranceRequestRelatedWizardSaved/insuranceRequestRelatedWizardSaved');
const InsuranceRequestWizardRequestError = require('./insuranceRequestWizardRequestError/insuranceRequestWizardRequestError');
const InsuranceRequestRelatedLeaveModalWrapper = require('./insuranceRequestRelatedLeaveModalWrapper/insuranceRequestRelatedLeaveModalWrapper')
const CoverageWrapper = require('../insuranceRequestDetailsContactCenter/coverageWrapper');

// @ actions
const insuranceRequestRelatedWizardActions = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedWizard');
const insuranceRequestRelatedModify = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedModify');
const insuranceRequestRelatedClear = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedClear');
const insuranceRequestRelatedWizardStep3 = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedWizardStep3');
const insuranceRequestRelatedStateActions = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedState');
const insuranceLegalDocumentsActions = require('../../actions/insuranceLegalDocuments');
const blockedAccountsActions = require('actions/blockedAccounts');
const mortgageRequestDataAction = require('actions/mortgageRequest/mortgageRequestMortgageData');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');

// @ constants
const { PROC_RELATED_INSURANCE, getInsuranceTag } = require('../../insuranceConstants/insuranceRequestTags');
const { MORTGAGE_PANEL } = require('../../insuranceConstants/insuranceRequestRoutes');
const {
    CC_INSURANCE_SEND_MAIL_CODES,
    PLANS: { BASIC },
    PROPERTY_USAGE_RELATED,
    WIZARD_REQUEST_RESPONSE_OPTIONS,
} = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP, FIFTH_STEP } = require('constants/index');
const {
    INSURANCES_PERFORMANCE_LIMITS,
    INSURANCE_RELATED_OTP_OPTION,
    INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION,
    INSURANCE_USABILITY_IMPROVEMENTS,
} = require('constants/flagBasedFeatures');

const { SUCCESS, IS_FETCHING, ERROR } = WIZARD_REQUEST_RESPONSE_OPTIONS;
const processes = {
    PROC_PRE_APPRAISAL: 'pre-tasacion',
    PROC_POST_APPRAISAL: 'post-tasacion'
}

class InsuranceRequestRelatedWizard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            didPlanChangeIndetailTable: false,
            isCancelingSimulation: false,
            selectedPlan: BASIC,
            showCoverageDetailTable: false,
        };

        this.onhandleCancel = this.onhandleCancel.bind(this);
        this.handleChangeShowCoverageDetailTable = this.handleChangeShowCoverageDetailTable.bind(this);
        this.hasSimulationChanged = this.hasSimulationChanged.bind(this);
        this.onhandleChangeSelectedPlanInStateComponent = this.onhandleChangeSelectedPlanInStateComponent.bind(this);
        this.onhandleSelectPlanInDetailTable = this.onhandleSelectPlanInDetailTable.bind(this);
        this.cancelingSimulation = this.cancelingSimulation.bind(this);
        this.handleModifyInsurance = this.handleModifyInsurance.bind(this);
        this.savePreviousId = this.savePreviousId.bind(this);
        this.recordEvent = this.recordEvent.bind(this);
        this.onAgreementCheckboxChange = this.onAgreementCheckboxChange.bind(this);
    }

    componentWillMount() {
        const {
            getInsurance,
            immInsuranceState,
            immInsuranceWizard,
            loadSteps,
        } = this.props;

        if (immInsuranceState.get('data')) {
            loadSteps(immInsuranceState.get('data').toJS());
        } else {
            getInsurance();
        }
        const selectedPlan = immInsuranceWizard.getIn(["steps", THIRD_STEP, "insurancePlan"])
        if (selectedPlan !== '') {
            this.setState({
                selectedPlan,
            })
        }
    }

    componentDidMount() {
        const { mortgageRequestMortgageData, setData } = this.props;

        const finalidad = mortgageRequestMortgageData.getIn(['data', 'finalidad'])

        if (finalidad !== '') {
            setData(SECOND_STEP, {
                propertyUsage: PROPERTY_USAGE_RELATED[finalidad]
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            immInsuranceState,
            loadSteps,
            mortgageRequestMortgageData,
            setData,
        } = this.props;

        if (nextProps.mortgageRequestMortgageData.get('data') !== mortgageRequestMortgageData.get('data')) {

            const usageRelated = nextProps.mortgageRequestMortgageData.getIn(['data', 'finalidad']);
            setData(SECOND_STEP, {
                propertyUsage: PROPERTY_USAGE_RELATED[usageRelated]
            });
        }
        if (nextProps.immInsuranceState.get('data') !== immInsuranceState.get('data')) {
            loadSteps(nextProps.immInsuranceState.get('data').toJS());
        }

        if (nextProps.immInsuranceWizard.get('visibleStep') === FIFTH_STEP) {
            this.setState({
                showCoverageDetailTable: false,
            });
        }
    }

    componentWillUnmount() {
        const {
            clearRequest,
            resetPrecontractualMail,
            setLinkedSimulationToInitial,
        } = this.props;
        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
        setLinkedSimulationToInitial();
        clearRequest();
    }

    onhandleCancel() {
        this.props.history.push(MORTGAGE_PANEL);
    }

    handleChangeShowCoverageDetailTable() {
        this.setState({
            showCoverageDetailTable: !this.state.showCoverageDetailTable
        });
    }

    savePreviousId(prevId) {
        const { setData, immInsuranceWizard } = this.props;
        const prevInsuranceId = immInsuranceWizard.getIn(['steps', FIFTH_STEP, 'prevInsuranceId']) || null;

        if (!prevInsuranceId) {
            setData(FIFTH_STEP, {
                prevInsuranceId: prevId
            });
        }
    }

    onhandleSelectPlanInDetailTable(selectedPlan) {
        const { validateStep, selectPlanInRelatedWizardStep3 } = this.props;
        selectPlanInRelatedWizardStep3(selectedPlan);
        validateStep(FOURTH_STEP);
    }

    hasSimulation() {
        const { immInsuranceState } = this.props;

        return immInsuranceState.get('data') !== null && !immInsuranceState.get('data').isEmpty();
    }

    hasSimulationChanged() {
        const { immInsuranceWizard } = this.props;

        return immInsuranceWizard.getIn(['steps', SECOND_STEP, 'simulationChanged']);
    }

    onhandleChangeSelectedPlanInStateComponent(selectedPlan, didChange = true) {
        this.setState({
            selectedPlan,
            didPlanChangeIndetailTable: didChange
        });
    }

    cancelingSimulation(isCancelingSimulation) {
        this.setState({
            isCancelingSimulation,
        })
    }

    handleModifyInsurance() {
        const { validateStep, modifyInsurance, setData } = this.props;
        modifyInsurance(true, false);
        validateStep(SECOND_STEP);
        setData(FIFTH_STEP, {
            prevInsuranceId: ''
        });
    }

    onAgreementCheckboxChange(evt) {
        const { setData } = this.props;
        setData(FIFTH_STEP, { agreementChecked: evt.target.checked });
    }

    recordEvent(event, extraTag) {
        const { immInsuranceWizard } = this.props;

        const step = PROC_STEP + immInsuranceWizard.get('visibleStep');
        recordProcess(PROC_RELATED_INSURANCE, step, getInsuranceTag(event, extraTag))
    }

    buildMortgageRequestManagerInfo() {
        return !__CONTACT_CENTER__
            ? (
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                    <div className="insurance-related-wizard__manager">
                        <MortgageRequestManagerInfo
                            managerTitle={formatText('mortgageRequestManagerInfo-yourManager')}
                        />
                    </div>
                </div>
            )
            : null;
    }

    getCoverageWrapperProps() {
        const { didPlanChangeIndetailTable } = this.state;
        const {
            clearRequest,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            linkClientSuccessInitialState,
            setData,
            validateStep,
         } = this.props;

        const currentPlan = immInsuranceWizard.getIn(['steps', THIRD_STEP, 'insurancePlan']);
        const isPostAppraisal = immInsuranceState.getIn(['appraisal', 'afterAppraisal']) || false;

        return {
            cancelingSimulation: this.cancelingSimulation,
            clearRequest,
            currentPlan,
            didPlanChangeIndetailTable,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            isPostAppraisal,
            isRelated: true,
            linkClientSuccessInitialState,
            onChangeShowCoverageDetailTable: this.handleChangeShowCoverageDetailTable,
            onhandleCancel: this.onhandleCancel,
            onhandleChangeSelectedPlanInStateComponent: this.onhandleChangeSelectedPlanInStateComponent,
            onhandleSelectPlanInDetailTable: this.onhandleSelectPlanInDetailTable,
            selectedPlan: this.state.selectedPlan,
            setData,
            validateStep,
        };
    }

    buildContactCenterCoverageWrapper() {
        const coverageWrapperProps = this.getCoverageWrapperProps();

        return (
            <CoverageWrapper
                {...coverageWrapperProps}
            />
        );
    }

    buildNormalCoverageWrapper() {
        const coverageWrapperProps = this.getCoverageWrapperProps();

        return (
            <InsuranceRequestDetailsTabsWrapper
                {...coverageWrapperProps}
            />
        );
    }

    buildCoverageWrapper() {
        const { immFlagBasedFeatures } = this.props;
        let coverageWrapper = null;
        const webActuationLimitsIsEnabled = immFlagBasedFeatures.get(INSURANCES_PERFORMANCE_LIMITS);

        if (__CONTACT_CENTER__ && webActuationLimitsIsEnabled) {
            coverageWrapper = this.buildContactCenterCoverageWrapper();
        } else {
            coverageWrapper = this.buildNormalCoverageWrapper();
        }

        return coverageWrapper;
    }

    buildInsuranceRequestStep3() {
        const {
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            getQuotationData,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            linkClientSuccessInitialState,
            selectPlanInRelatedWizardStep3,
            setData,
            validateStep,
        } = this.props;
        const isPostAppraisal = immInsuranceState.getIn(['appraisal', 'afterAppraisal']) || false;
        const step3Props = {
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            getQuotationData,
            hasSimulationChanged: this.hasSimulationChanged(),
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            isPostAppraisal,
            isRelated: true,
            linkClientSuccessInitialState,
            onChangeShowCoverageDetailTable: this.handleChangeShowCoverageDetailTable,
            onhandleChangeSelectedPlanInStateComponent: this.onhandleChangeSelectedPlanInStateComponent,
            recordEvent: this.recordEvent,
            selectPlanInRelatedWizardStep3,
            setData,
            validateStep,
            webActuationLimitsIsEnabled: immFlagBasedFeatures.get(INSURANCES_PERFORMANCE_LIMITS),
        }
        return __CONTACT_CENTER__ ?
            (<InsuranceRequestWizardStep3CC
                {...step3Props}
            />) :
            (<InsuranceRequestWizardStep3
                {...step3Props}
            />);
    }

    render() {
        const {
            changeErrorPopulation,
            changeErrorPostalCode,
            clearPostalCodeError,
            clearRequest,
            getBlockedAccounts,
            getDocument,
            getDocumentsSummary,
            getDocumentsZip,
            getPaymentAccount,
            getPopulationData,
            getRecommendation,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceLegalDocuments,
            immInsuranceRequestModify,
            immInsuranceState,
            immInsuranceWizard,
            immPreContractualMail,
            immProfile,
            modifyInsurance,
            mortgageRequestMortgageData,
            onPrintDocument,
            requestProfile,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetStep,
            sendPreContractualMail,
            setData,
            setPostAppraisalInitialData,
            setVisibleStep,
            setWillCancel,
            validateStep,
        } = this.props;

        const { showCoverageDetailTable, isCancelingSimulation } = this.state;
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const immInsuranceWizardStep4 = immInsuranceWizard.getIn(['steps', FOURTH_STEP]);
        const immInsuranceWizardStep5 = immInsuranceWizard.getIn(['steps', FIFTH_STEP]);

        const isPostAppraisal = immInsuranceState.getIn(['appraisal', 'afterAppraisal']) || false;
        const isPostAppraisalClosedPrice = immInsuranceState.get('isPostAppraisalClosedPrice');
        const wizardRequestResponse = immInsuranceWizard.get('wizardRequestResponse');
        const linkingSimulation = immInsuranceWizardStep3.get('isLinkingInProgress');
        const islinkingSuccess = immInsuranceWizardStep3.get('islinkingSuccess');
        const linkedSimulation = immInsuranceWizardStep3.get('linkedSimulation');
        const insuranceIsBeingModified = immInsuranceRequestModify.get('insuranceIsBeingModified');
        const insuranceHasBeenModified = immInsuranceRequestModify.get('insuranceHasBeenModified');
        const insuranceModifyIsFetching = immInsuranceRequestModify.get('insuranceModifyIsFetching');
        const appraisalState = immInsuranceState.getIn(['appraisal', 'state']);
        const insuranceId = immInsuranceWizardStep3.getIn(["quotationData", "idInsurance"]);
        const serviceError = immInsuranceState.get('error') ||
            mortgageRequestMortgageData.get('error') ||
            immInsuranceWizardStep3.get('errorDetails') ||
            immInsuranceWizardStep3.get('errorQuotation') ||
            immInsuranceWizardStep3.get('cancelError') ||
            immInsuranceWizardStep3.get('error') ||
            immInsuranceWizardStep3.get('errorSelectPlan') ||
            immInsuranceWizardStep3.get('linkingError') ||
            immInsuranceWizardStep4.get('errorPricing') ||
            immInsuranceWizardStep4.get('errorSave') ||
            immInsuranceWizardStep4.get('errorPayment') ||
            immInsuranceWizard.get('modifyRequestError');
        const sendMailParams = {
            code: CC_INSURANCE_SEND_MAIL_CODES.HOME_INSURANCE_REQUEST_RELATED,
            id: immInsuranceState.getIn(['data', 'id']),
        };
        const mortgageRequestManagerInfo = this.buildMortgageRequestManagerInfo();
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const step2NextButtonDisabled = (isInsuranceUsabilityImprovementsEnabled && !immInsuranceWizardStep2.get('valid'));
        const insuranceRelatedOtpOption = immFlagBasedFeatures.get(INSURANCE_RELATED_OTP_OPTION);
        const finalButtonDisabled = insuranceRelatedOtpOption && !immInsuranceWizardStep5.get('acceptedConditions');
        const preAppraisalNotificationFlag = immFlagBasedFeatures.get(INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION);

        let operativeName;
        if (__CONTACT_CENTER__) {
            operativeName = 'operatives-combined_home_insurance';
        }
        if (insuranceModifyIsFetching) {
            return <LoadingSection />;
        } else if ((wizardRequestResponse === SUCCESS || isPostAppraisalClosedPrice === SUCCESS) && !insuranceIsBeingModified && immInsuranceState.get('data')) {
            return (
                <InsuranceRequestRelatedWizardSaved
                    appraisalState={appraisalState}
                    getPaymentAccount={getPaymentAccount}
                    hasSimulation={this.hasSimulation()}
                    hasSimulationChanged={this.hasSimulationChanged()}
                    immAccounts={immAccounts}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardState={immInsuranceWizard}
                    insuranceHasBeenModified={insuranceHasBeenModified}
                    isPostAppraisal={isPostAppraisal}
                    isRelated
                    notifyWrapUp={false}
                    onHandleModifyInsurance={this.handleModifyInsurance}
                    onModifyInsuranceAction={modifyInsurance}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            );
        } else if (
            !immInsuranceState.get('hasFetched') &&
            immInsuranceState.get('isFetching') ||
            isPostAppraisalClosedPrice === IS_FETCHING ||
            isCancelingSimulation ||
            wizardRequestResponse === IS_FETCHING) {
            return <LoadingSection />;
        } else if (showCoverageDetailTable) {
            return this.buildCoverageWrapper();
        } else if (!isPostAppraisal && linkedSimulation) {
            return (
                <InsuranceRequestRelatedWizardSaved
                    hasSimulation={this.hasSimulation()}
                    hasSimulationChanged={this.hasSimulationChanged()}
                    immAccounts={immAccounts}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardState={immInsuranceWizard}
                    isPostAppraisal={isPostAppraisal}
                    isRelated
                    notifyWrapUp={false}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            );
        } else if (wizardRequestResponse === ERROR || isPostAppraisalClosedPrice === ERROR || serviceError) {
            return (
                <InsuranceRequestWizardRequestError
                    buttonLabel={formatText('mortgageRequestError-returnLoans')}
                    buttonLink={MORTGAGE_PANEL}
                    isRelated={true}
                    setData={setData}
                />
            );
        }

        const relatedWizardClasses = classNames(
            'insurance-related-wizard',
            'row',
            {
                'insurance-related-wizard--post-appraisal': isPostAppraisal
            }
        );

        const postalCode = immInsuranceWizardStep2.get('postalCode');

        const wizardActions = {
            cancel: this.onhandleCancel,
            finish: () => { },
            resetStep,
            setVisibleStep,
            setWillCancel,
            validateStep,
        };
        const tealium = {
            detalleProceso: isPostAppraisal ? processes.PROC_POST_APPRAISAL : processes.PROC_PRE_APPRAISAL
        }

        return (
            <div className={relatedWizardClasses}>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immInsuranceWizard.get('steps')}
                        isFetching={false}
                        tealium={tealium}
                        stepsAmount={immInsuranceWizard.get('steps').size}
                        visibleStep={immInsuranceWizard.get('visibleStep')}
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            cancelButton={true}
                            position="first"
                        >
                            <InsuranceRequestWizardStep1
                                isRelated
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            nextButton={true}
                            nextButtonDisabled={step2NextButtonDisabled}
                            position="middle"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep2Related
                                changeErrorPopulation={changeErrorPopulation}
                                changeErrorPostalCode={changeErrorPostalCode}
                                clearPostalCodeError={clearPostalCodeError}
                                getPopulationData={getPopulationData}
                                getRecommendation={getRecommendation}
                                getTranslation={this.getTranslation}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardStep={immInsuranceWizardStep2}
                                isPostAppraisal={isPostAppraisal}
                                recordEvent={this.recordEvent}
                                savePreviousId={this.savePreviousId}
                                setData={setData}
                                setPostAppraisalInitialData={setPostAppraisalInitialData}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            isLoading={(linkingSimulation && !linkedSimulation) || islinkingSuccess}
                            nextButton={true}
                            position="middle"
                            previousButton={true}
                        >
                            {this.buildInsuranceRequestStep3()}
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            isLoading={immInsuranceWizardStep4.get('setPaymentAccountInProgress') || immInsuranceWizardStep4.get('isSaving')}
                            nextButton={true}
                            position="middle"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep4
                                getBlockedAccounts={getBlockedAccounts}
                                getPaymentAccount={getPaymentAccount}
                                goBackStep={setVisibleStep}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardStep={immInsuranceWizardStep4}
                                isRelated
                                postalCode={postalCode}
                                resetBlockedAccounts={resetBlockedAccounts}
                                setData={setData}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={!insuranceRelatedOtpOption}
                            cancelButton={true}
                            ccDefaultBehaviour={insuranceRelatedOtpOption}
                            finalButtonDisabled={finalButtonDisabled}
                            finishButton={false}
                            immFinalButton="common-confirm"
                            position="last"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep5
                                contractName={operativeName}
                                getDocument={getDocument}
                                getDocumentsSummary={getDocumentsSummary}
                                getDocumentsZip={getDocumentsZip}
                                getPaymentAccount={getPaymentAccount}
                                handleAgreementCheckboxChange={this.onAgreementCheckboxChange}
                                hasSimulation={this.hasSimulation()}
                                hasSimulationChanged={this.hasSimulationChanged()}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceLegalDocuments={immInsuranceLegalDocuments}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardPrevStep={immInsuranceWizardStep4}
                                immInsuranceWizardState={immInsuranceWizard}
                                immInsuranceWizardStep={immInsuranceWizardStep5}
                                immPreContractualMail={immPreContractualMail}
                                immProfile={immProfile}
                                isPostAppraisal={isPostAppraisal}
                                isRelated={true}
                                onPrintDocument={onPrintDocument}
                                requestProfile={requestProfile}
                                resetPrecontractualMail={resetPrecontractualMail}
                                sendMailParams={sendMailParams}
                                sendPreContractualMail={sendPreContractualMail}
                                setData={setData}
                                insuranceRelatedOtpOption={insuranceRelatedOtpOption}
                            />
                        </WizardStep>
                    </Wizard>
                </div>

                <div className="col-xs-12 col-md-4">
                    {mortgageRequestManagerInfo}
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                        <InsuranceRequestCompilationCard
                            hasSimulation={this.hasSimulation()}
                            hasSimulationChanged={this.hasSimulationChanged()}
                            immInsuranceState={immInsuranceState}
                            immInsuranceWizardState={immInsuranceWizard}
                            isRelated={true}
                            preAppraisalNotificationFlag={preAppraisalNotificationFlag}
                        />
                    </div>
                </div>
                <InsuranceRequestRelatedLeaveModalWrapper
                    cancelingSimulation={this.cancelingSimulation}
                    clearRequest={clearRequest}
                    immInsuranceWizard={immInsuranceWizard}
                    insuranceId={insuranceId}
                    insuranceIsBeingModified
                    isPostAppraisalClosedPrice={isPostAppraisalClosedPrice}
                />
            </div>
        );
    }
}

InsuranceRequestRelatedWizard.propTypes = {
    changeErrorPopulation: PropTypes.func.isRequired,
    changeErrorPostalCode: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getCoveragesAndPlansData: PropTypes.func.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getDocument: PropTypes.func.isRequired,
    getDocumentsSummary: PropTypes.func.isRequired,
    getDocumentsZip: PropTypes.func.isRequired,
    getInsurance: PropTypes.func.isRequired,
    getPaymentAccount: PropTypes.func.isRequired,
    getPopulationData: PropTypes.func.isRequired,
    getQuotationData: PropTypes.func.isRequired,
    getRecommendation: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInsuranceLegalDocuments: PropTypes.object.isRequired,
    immInsuranceRequestModify: PropTypes.object.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    linkClientSuccessInitialState: PropTypes.func,
    loadSteps: PropTypes.func.isRequired,
    modifyInsurance: PropTypes.func.isRequired,
    mortgageRequestMortgageData: PropTypes.object.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    requestMortgageData: PropTypes.func,
    requestProfile: PropTypes.func,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func,
    resetStep: PropTypes.func,
    selectPlanInRelatedWizardStep3: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func,
    setData: PropTypes.func.isRequired,
    setLinkedSimulationToInitial: PropTypes.func,
    setPostAppraisalInitialData: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

InsuranceRequestRelatedWizard.defaultProps = {
    setLinkedSimulationToInitial: () => { },
    linkClientSuccessInitialState: () => { },
};

module.exports.constructor = InsuranceRequestRelatedWizard;

module.exports.InsuranceRequestRelatedWizard = withRouter(connect(state => (
    {
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInsuranceLegalDocuments: state.insuranceRequestLegalDocuments,
        immInsuranceRequestModify: state.insuranceRequestModify,
        immInsuranceState: state.insuranceRequestRelatedState,
        immInsuranceWizard: state.insuranceRequestRelatedWizard,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        mortgageRequestMortgageData: state.mortgageRequestMortgageData,
    }),
    {
        changeErrorPopulation: insuranceRequestRelatedWizardActions.changeErrorPopulation,
        changeErrorPostalCode: insuranceRequestRelatedWizardActions.changeErrorPostalCode,
        clearPostalCodeError: insuranceRequestRelatedWizardActions.clearPostalCodeError,
        clearRequest: insuranceRequestRelatedClear.clearRequest,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        getCoveragesAndPlansData: insuranceRequestRelatedWizardStep3.getCoveragesAndPlansData,
        getCoveragesAndPlansDetailsData: insuranceRequestRelatedWizardStep3.getCoveragesAndPlansDetailsData,
        getDocument: insuranceRequestRelatedWizardActions.getDocument,
        getDocumentsSummary: insuranceLegalDocumentsActions.getDocumentsSummary,
        getDocumentsZip: insuranceLegalDocumentsActions.getDocumentsZip,
        getInsurance: insuranceRequestRelatedStateActions.requestInsuranceRelatedCurrentState,
        getPaymentAccount: insuranceRequestRelatedWizardActions.getPaymentAccount,
        getPopulationData: insuranceRequestRelatedWizardActions.getPopulationData,
        getQuotationData: insuranceRequestRelatedWizardStep3.getQuotationData,
        getRecommendation: insuranceRequestRelatedStateActions.requestInsuranceRelatedRecommendation,
        insuranceSelectPlan: insuranceRequestRelatedWizardStep3.linkClient,
        linkClientSuccessInitialState: insuranceRequestRelatedWizardStep3.linkClientSuccessInitialState,
        loadSteps: insuranceRequestRelatedWizardActions.loadSteps,
        modifyInsurance: insuranceRequestRelatedModify.modifyInsurance,
        onPrintDocument: insuranceLegalDocumentsActions.onPrintDocument,
        requestMortgageData: mortgageRequestDataAction.requestMortgageData,
        requestProfile: profileActions.requestProfile,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetStep: insuranceRequestRelatedWizardActions.resetStep,
        selectPlanInRelatedWizardStep3: insuranceRequestRelatedWizardStep3.selectPlanInRelatedWizardStep3,
        sendPreContractualMail: preContractualMailActions.sendInsurancePrecontractualMail,
        setData: insuranceRequestRelatedWizardActions.setData,
        setLinkedSimulationToInitial: insuranceRequestRelatedWizardStep3.setLinkedSimulationToInitial,
        setPostAppraisalInitialData: insuranceRequestRelatedWizardActions.setPostAppraisalInitialData,
        setVisibleStep: insuranceRequestRelatedWizardActions.setVisibleStep,
        setWillCancel: insuranceRequestRelatedWizardActions.setWillCancel,
        validateStep: insuranceRequestRelatedWizardActions.validateStep,
    }
)(InsuranceRequestRelatedWizard));
